import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ownerWindow } from '@material-ui/core/utils';
import ResizeObserver from 'resize-observer-polyfill';
var popperPlacement = {
  bottom: 'bottom-start',
  top: 'top-start'
};

var getNode = function getNode(object) {
  return object && Object.prototype.hasOwnProperty.call(object, 'current') ? object.current : object;
};

export var usePopperPositioning = function usePopperPositioning(anchor, list, isOpen) {
  var anchorMayResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var anchorNode = getNode(anchor);
  var listNode = getNode(list);

  var _useState = useState(undefined),
      maxHeight = _useState[0],
      setMaxHeight = _useState[1];

  var _useState2 = useState(popperPlacement.bottom),
      popperPosition = _useState2[0],
      setPopperPosition = _useState2[1];

  var preferredPopperHeight = useRef(-1);

  var _useState3 = useState(0),
      spaceAbove = _useState3[0],
      setSpaceAbove = _useState3[1];

  var _useState4 = useState(0),
      spaceBelow = _useState4[0],
      setSpaceBelow = _useState4[1];

  var measure = useCallback(function () {
    var _ownerWindow = ownerWindow(anchorNode),
        viewportHeight = _ownerWindow.innerHeight;

    var _anchorNode$getBoundi = anchorNode.getBoundingClientRect(),
        top = _anchorNode$getBoundi.top,
        bottom = _anchorNode$getBoundi.bottom;

    setSpaceAbove(Math.max(0, top));
    setSpaceBelow(Math.max(0, viewportHeight - bottom));
  }, [anchorNode]);
  useEffect(function () {
    if (anchorNode && isOpen) {
      measure();
      var win = ownerWindow(anchorNode);
      win.addEventListener('resize', measure);
      win.addEventListener('scroll', measure);
      var resizeObserver = null;

      if (anchorMayResize) {
        resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(anchorNode);
      }

      return function () {
        win.removeEventListener('resize', measure);
        win.removeEventListener('scroll', measure);
        resizeObserver && resizeObserver.disconnect();
      };
    }
  }, [anchorNode, anchorMayResize, measure, isOpen]);
  useLayoutEffect(function () {
    if (isOpen) {
      // This will be the full height, based on defaultRowCount
      // we only need to measure it once
      if (listNode && preferredPopperHeight.current === -1) {
        preferredPopperHeight.current = listNode.offsetHeight;
      }

      var newMaxHeight = undefined;
      var position = undefined;

      if (spaceBelow >= preferredPopperHeight.current) {
        newMaxHeight = undefined;
        position = popperPlacement.bottom;
      } else if (spaceAbove > preferredPopperHeight.current) {
        newMaxHeight = undefined;
        position = popperPlacement.top;
      } else if (spaceAbove > spaceBelow) {
        newMaxHeight = spaceAbove;
        position = popperPlacement.top;
      } else {
        newMaxHeight = spaceBelow - 12;
        position = popperPlacement.bottom;
      }

      setMaxHeight(newMaxHeight);
      setPopperPosition(position);
    } else {
      // Reset on popper close
      setMaxHeight(undefined);
      setPopperPosition(undefined);
    }
  }, [isOpen, listNode, spaceAbove, spaceBelow]);
  return [popperPosition, maxHeight];
};